// extracted by mini-css-extract-plugin
export default {"main":"style_main__C4F78","head":"style_head__tu-a+","head_devider":"style_head_devider__z+8yE","head_title":"style_head_title__9DhJv","title":"style_title__yjkds"};